<template>
  <div id="toptab">
    <ul>
        <li class="topback" v-show="topback" @click="backhome()">
          <i class="el-icon-arrow-left"></i>
        </li>
        <li class="toptableft">
          <a href="/">
            <img :src="website.web_logo" alt="" class="logo">
          </a>
          <span>人人都能用的文生视频系统</span>
        </li>
        <li class="toptabright">
            <div v-if="login">
              <el-popover
                placement="bottom"
                width="300"
                trigger="hover">
                <div class="popverBox">
                  <div class="usermsg">
                    <div>
                      <el-avatar slot="reference" :size="58" :src="userdata.avatar" ></el-avatar>
                    </div>
                    <div>
                      <p class="username">{{userdata.nickname}}</p>
                      <p class="id">{{userdata.id}} <span class="icon"></span></p>
                    </div>
                  </div>
                  <div class="point">
                    当前可用分钟数: <span>{{userdata.ai_drop}}</span>
                  </div>
                  <!-- <div class="info">
                    <div>
                      <p>{{userdata.vip.title}}</p>
                      <p>{{userdata.vip.content}}</p>
                    </div>
                    <div @click="dialogVisible=true">
                      <p>{{userdata.vip.show_btn_text}}</p>
                    </div>
                  </div> -->
                  <div class="buttonbox">
                    <p @click="loginout">退出登录</p>
                  </div>
                </div>
                <el-avatar slot="reference" :size="32" :src="userdata.avatar" ></el-avatar>
              </el-popover>
          </div>
        </li>
    </ul>
    <membertc v-if="dialogVisible" @closemember="closemember"></membertc>
  </div>
</template>

<script>
import { userInfo } from "@/api/user";
import { indexConfig } from "@/api/login";
import membertc from '@/components/membertc'
export default {
  components:{
    membertc
  },
  props:{
    topback: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      dialogVisible:false,
      login:false,
      website:this.$store.website,
      userdata:{
        avatar:"",
        vip:{}
      }
    }
  },
  mounted(){
    // indexConfig().then(res=>{
    //   this.website = res.data
    // })
    if(localStorage.getItem('gpt-token')){
      this.userdata=this.$store.userInfo
      this.login = true
    }else{
      this.login = false
    }
  },
  methods:{
    closemember(){
      this.dialogVisible = false
    },
    backhome(){
      this.$router.push({ path: '/' })
    },
    loginout(){
      // localStorage.setItem('login',false);
      localStorage.removeItem('gpt-token')
      localStorage.removeItem('need_bind_mobile')
      localStorage.setItem('loginStatus',0)
      location.reload()
    }
  }
}
</script>

<style lang="less">
  #toptab{
    height: 60px;
    padding: 0 24px;
    border-bottom: 1px solid #f4f5f7;
    ul{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .topback{
        width: 36px;
        height: 36px;
        border: 1px solid #e6e9ed;
        border-radius: 8px;
        font-size: 28px;
        // transform: rotate(180deg);
        color: #999;
        cursor: pointer;
        // transition: all .2s linear;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .toptableft{
        display: flex;
        align-items: center;
        color: #4e5969;
        font-size: 14px;
        flex: 1 0 10%;
        a{
          height: 36px;
          width: 118.5px;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          .logo{
            width: 88px;
          }
        }
      }
    }
  }
  .popverBox{
    .usermsg{
      display: flex;
      align-items: center;
      div:nth-child(1){
        margin-right: 8px;

      }
      div:nth-child(2){
        .username{
          color: rgb(96, 98, 102);
          font-size: 14px;
          margin-bottom: 8px;
        }
        .id{
          color: #999;
          font-size: 12px;
          display: flex;
          align-items: center;
          span{
            width: 12px;
            height: 12px;
            cursor: pointer;
            background-position: -1px 0px;
            background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
            display: inline-block;
            margin-left: 4px;
          }
        }
      }
    }

    .point{
      margin: 12px 0 16px;
      color: #999;
      font-size: 12px;
      span{
            color: #2d8af5;
      }
    }

    .info{
      height: 80px;
      border-radius: 8px;
      padding: 18px 16px;
      justify-content: space-between;
      background: linear-gradient(94.94deg,#e4e8ff .7%,#f7f5ff 44.6%,#fef1ff 100%);
      cursor: pointer;
      display: flex;
      align-items: center;
      div:nth-child(1){
        p:nth-child(1){
          color: rgb(96, 98, 102);
          font-size: 14px;
          margin-bottom: 8px;
        }
        p:nth-child(2){
          font-size: 12px;
          color: #999;
        }
      }
      div:nth-child(2){
        p{
          width: 80px;
          height: 32px;
          background: #ffffff;
          box-shadow: 0 3px 8px rgba(50,59,176,.07);
          border-radius: 4px;
          font-size: 12px;
          color: #2d8af5;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .buttonbox{
      border-top: 1px solid rgb(244, 245, 247);
      color:rgb(96, 98, 102);
      font-size: 12px;
      margin: 16px 0 12px;
      padding-top: 10px;
      p{
        cursor: pointer;
        padding: 11px 16px;
        border-radius: 4px;
      }
      p:hover{
        background: #f2f3f5;
      }
    }
  }
</style>